import Icon from "@mdi/react";
import {mdiLoading} from "@mdi/js";
import React, {useEffect, useState} from "react";
import stiles from "./PricingPanel.scss"
import UELogo from "./UELogo";
import {connect} from "react-redux";
const PricingCollectivePortailRight = ({setCurrentCenterPage,setShowPricing, portailPrices})=>{

    const [selected, setSelected] = useState(null);
    const [codesTerr, setCodesTerr] = useState(""); // New state for select input
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (portailPrices.length > 0) {
            setSelected(portailPrices[0]);
        }
    }, [portailPrices]);

    const handleActive = (item) => {
        setSelected(item);
    };

    const handleClick = async () => {
        if (!selected) {
            setError('Please select a subscription plan.');
            return;
        }

        if (!codesTerr) {
            setError('Please select a territory.');
            return;
        }

        setLoading(true);
        setError(null);

        try {
            // Make a POST request to the backend to create a Checkout session
            const response = await axios.post('/Api/checkout/create-session', {
                subscription_type_id: selected.id,
                codes_terr: codesTerr, // Send the selected codes_terr
            });

            const { url } = response.data;

            // Redirect to Stripe Checkout
            window.location.href = url;
        } catch (err) {
            console.error(err);
            setError(err.response?.data?.error || 'An error occurred while processing your request.');
            setLoading(false);
        }
    };

    const renderItem = (item)=>{
        return <div key={item.id} className={selected&&item?.id===selected?.id
            ?"d-flex justify-content-between ue-portail-terr-price-item active"
            :"d-flex justify-content-between ue-portail-terr-price-item "
        }
                    onClick={()=>handleActive(item)}
        >
                <div className={"d-flex justify-content-start align-items-start"}>
                    <svg width="11" height="11" viewBox="0 0 11 11" fill="#70979A" xmlns="http://www.w3.org/2000/svg" style={{"marginRight": "22px" ,"marginTop":"8px"}}>
                        <path d="M5.5 0C2.46243 0 0 2.46243 0 5.5C0 8.53757 2.46243 11 5.5 11C8.53757 11 11 8.53757 11 5.5C11 2.46243 8.53757 0 5.5 0ZM7.27419 5.5C7.27419 6.47829 6.47829 7.27419 5.5 7.27419C4.52171 7.27419 3.72581 6.47829 3.72581 5.5C3.72581 4.52171 4.52171 3.72581 5.5 3.72581C6.47829 3.72581 7.27419 4.52171 7.27419 5.5Z"  fillOpacity="0.8"/>
                    </svg>
                    <div className={""}>
                        <p className={"h2 font-weight-bold mb-2"}>{item.title}</p>
                        <p className={""}>{item.subtitle}</p>
                    </div>
                </div>
                <div className={"d-flex flex-row align-items-center "}>
                    {item?.price
                        ?<>
                            <div className={"ue-item-price"}><span className={""}>€</span> {Number(item?.price)/100}</div>
                            <div className={"d-flex flex-column justify-content-center align-items-start"}>
                                <div>ttc</div>
                                <div>{item.period}</div>
                            </div>
                        </>
                        :<div className={"d-flex flex-column justify-content-center align-items-end"}>
                            <div className={"h3 font-weight-bold my-2"}>Contactez</div>
                            <div>nous</div>
                        </div>
                    }
                </div>
        </div>
    }

    return (
        <>
            {portailPrices.length ? portailPrices.map(renderItem) : null}
            <div className="d-flex mt-3 flex-column justify-content-center align-items-center ue-portail-terr-price-item">
                <select
                    className="form-control"
                    value={codesTerr}
                    onChange={(e) => setCodesTerr(e.target.value)}
                >
                    <option value="" disabled>
                        Sélectionnez une EPCI
                    </option>
                    <option disabled>Corse-du-Sud</option>
                    <option value="242010056">CA du Pays ajaccien</option>
                    <option value="242000495">CC de l'Alta Rocca</option>
                    <option value="242000503">CC du Celavu-Prunelli</option>
                    <option value="200067049">CC de Spelunca-Liamone</option>
                    <option value="200038958">CC de la Pieve de l'Ornano</option>
                    <option value="242010130">CC Sartenais-Valinco</option>
                    <option value="200040764">CC Sud Corse</option>
                    <option disabled>Haute-Corse</option>
                    <option value="242000354">CA de Bastia</option>
                    <option value="242020105">CC de Calvi Balagne</option>
                    <option value="200042943">CC du Cap Corse</option>
                    <option value="200073252">CC Castagniccia-Casinca</option>
                    <option value="242020071">CC du Centre Corse</option>
                    <option value="200034205">CC de la Costa Verde</option>
                    <option value="200033827">CC de Fium'orbu Castellu</option>
                    <option value="200073104">CC de l'Île-Rousse - Balagne</option>
                    <option value="200036499">CC de Marana-Golo</option>
                    <option value="200073120">CC Nebbiu - Conca d'Oro</option>
                    <option value="200015162">CC de l'Oriente</option>
                    <option value="200073138">CC Pasquale Paoli</option>
                </select>
            </div>
           
            <div
                className="d-flex flex-column justify-content-center align-items-center w-100 btn btn-primary rounded rounded-lg btn-block text-white my-2"
                style={{ maxWidth: "506px" }}
                onClick={handleClick}
            >
                <div className="h3 font-weight-bold">CONTINUER</div>
            </div>
            {error && <div className="alert alert-danger mt-2">{error}</div>}
            {loading && <Icon path={mdiLoading} size={1} spin />}
        </>
    );
};
const mapStateToProps = state => {
    return {
        idUser: state.MeReducer.id,
        entity: state.MeReducer.entity,
    }
}

const mapDispatchTProps = dispatch => {
    return {
        setCurrentCenterPage: (e) => dispatch({type: 'SET_CURRENT_PAGE', data:e}),
        setShowPricing : (e)=>dispatch({type: 'SET_SHOW_PRICING', data:e}),
    }
}

export default connect(mapStateToProps, mapDispatchTProps)(PricingCollectivePortailRight)

